module.exports = __webpack_public_path__ + "img/RiderFlow_icon.776b5726.png";